<div fxLayout="column" fxLayoutGap="10px">

    <div fxLayout="row" fxLayoutGap="15px">
        <div fxLayout="column" fxFlex="55" fxLayoutGap="10px">

            <text-input-ctrl [caption]="'admin-center.employee.name'" [formControlName]="'name'"
                [settings]="{fxFill:true,firstLetterUpper:true}">
            </text-input-ctrl>
            <text-input-ctrl [caption]="'admin-center.employee.surname'" [formControlName]="'surname'"
                [settings]="{fxFill:true,firstLetterUpper:true}">
            </text-input-ctrl>
            <text-input-ctrl [caption]="'admin-center.employee.position'" [formControlName]="'position'"
                [settings]="{fxFill:true,firstLetterUpper:true}">
            </text-input-ctrl>

            <app-employee-select-ctrl [caption]="'admin-center.employee.supervisorEmployee'" [settings]="{fxFill:true}"
                [formControlName]="'supervisorEmployeeId'"></app-employee-select-ctrl>

            <static-dictionary-select-ctrl [settings]="{fxFill:true}" [caption]="'admin-center.employee.agreementType'"
                [formControlName]="'agreementTypeId'" [orderById]="true" [staticDictionaryName]="'agreementType'">
            </static-dictionary-select-ctrl>

            <textarea-input-ctrl [caption]="'admin-center.employee.additionalInfo'" [formControlName]="'additionalInfo'"
                [settings]="{fxFill:true, rows:3}">
            </textarea-input-ctrl>

        </div>

        <div fxLayout="column" fxFlex="40" fxLayoutGap="10px">

            <checkbox-input-ctrl [settings]="{fxFill:true}" [caption]="'admin-center.employee.isInternalEmployee'"
                [formControlName]="'isInternalEmployee'">
            </checkbox-input-ctrl>

            <checkbox-input-ctrl [settings]="{fxFill:true}" [caption]="'admin-center.employee.hasInspectionRoleAllowed'"
                [formControlName]="'hasInspectionRoleAllowed'">
            </checkbox-input-ctrl>

            <checkbox-input-ctrl [settings]="{fxFill:true}" [caption]="'admin-center.employee.hasTechnicianRoleAllowed'"
                [formControlName]="'hasTechnicianRoleAllowed'">
            </checkbox-input-ctrl>

            <checkbox-input-ctrl [settings]="{fxFill:true}" [caption]="'admin-center.employee.hasAssemblyRoleAllowed'"
                [formControlName]="'hasAssemblyRoleAllowed'">
            </checkbox-input-ctrl>

            <checkbox-input-ctrl [settings]="{fxFill:true}"
                [caption]="'admin-center.employee.hasEmployeeTechnicianAllowed'"
                [formControlName]="'hasEmployeeTechnicianAllowed'">
            </checkbox-input-ctrl>

            <checkbox-input-ctrl [settings]="{fxFill:true}"
                [caption]="'admin-center.employee.hasEmployeeMeritoricAllowed'"
                [formControlName]="'hasEmployeeMeritoricAllowed'">
            </checkbox-input-ctrl>

               <checkbox-input-ctrl [settings]="{fxFill:true}"
                [caption]="'admin-center.employee.hasEmployeeExpertTechnicianAllowed'"
                [formControlName]="'hasEmployeeExpertTechnicianAllowed'">
            </checkbox-input-ctrl>

            <checkbox-input-ctrl [settings]="{fxFill:true}"
                [caption]="'admin-center.employee.hasEmployeeExpertMeritoricAllowed'"
                [formControlName]="'hasEmployeeExpertMeritoricAllowed'">
            </checkbox-input-ctrl>

            <checkbox-input-ctrl [settings]="{fxFill:true}"
                [caption]="'admin-center.employee.hasPartsHandlingEmployeeAllowed'"
                [formControlName]="'hasPartsHandlingEmployeeAllowed'">
            </checkbox-input-ctrl>


        </div>
    </div>
</div>